import { LoadingSpinner } from './ui/LoadingSpinner';

export default function PageLoader() {
  return <LoadingSpinner fullPage message="Loading..." />;
}
